var app = angular.module('leonardo');

var MergeUnitsDetailsController = function ($scope, $rootScope, $element, $state, $location) {
  function emitEvent(toState, toParams) {
    var event = new CustomEvent('changeLocation', { detail: { toState, toParams } });
    var element = document.querySelector('#merge-units-edit-page');
    if (element) {
      element.dispatchEvent(event);
    }
  }

  $scope.$on('$stateChangeStart', function (event, toState, toParams) {
    if (window.pendingMerge) {
      event.preventDefault();
      emitEvent(toState, toParams);
    }
  });

  window.onbeforeunload = function () {
    if (window.pendingMerge) {
      return false;
    }
    return null;
  };

  $rootScope.loadReact({
    selector: '#merge-units',
    $element,
    component: window.reactComponent.MergeUnitsEditPage,
    data: {
      breadcrumbs: [
        { name: 'Utilities', icon: 'perm_contact_calendar' },
        { name: $state.$current.parent.navigable.self.ncyBreadcrumb.label, href: '#' + ($state.$current.parent.name.replace('.', '/')) }
      ],
      baseRoute: $state.$current.parent ? `#/${$state.$current.parent.name.replace('.', '/')}` : `#${$location.$$url}`,
      filters: {
        account: $state.params.account,
        portfolio: $state.params.portfolio,
        group: $state.params.group,
        property: $state.params.property || $state.params.id
      },
      property: $state.params.id,
      search: $state.params.search
    }
  });
};

app.controller('MergeUnitsDetailsController', ['$scope', '$rootScope', '$element', '$state', '$location', MergeUnitsDetailsController]);
